import { Background360 } from "./Background360";
import {
  defaultBackground360Config,
  defaultColorBackgroundConfig,
  defaultStaticBackgroundConfig,
} from "./constants";
import { ColorBackground, StaticBackground } from "./index";
import {
  AssetBackground360Props,
  AssetBackgroundProps,
  BackgroundsProps,
  ColorBackgroundProps,
  NvsBackgroundTypes,
  NvsBackgroundsValue,
} from "./types";
import { get } from "lodash";

type BackgroundsJSXElement = (
  props: BackgroundsProps<
    ColorBackgroundProps | AssetBackgroundProps | AssetBackground360Props | null
  >,
) => JSX.Element;

export const BackgroundsMap = {
  [NvsBackgroundTypes.ColorBackground]: (props: ColorBackgroundProps) => (
    <ColorBackground {...props} />
  ),
  [NvsBackgroundTypes.StaticBackground]: (props: AssetBackgroundProps) => (
    <>{props.asset.url && <StaticBackground {...props} />}</>
  ),
  [NvsBackgroundTypes.Background360]: (props: AssetBackground360Props) => (
    <>{props.asset.url && <Background360 {...props} />}</>
  ),
};

export const BackgroundsDefaultPropMap = {
  [NvsBackgroundTypes.ColorBackground]: defaultColorBackgroundConfig,
  [NvsBackgroundTypes.StaticBackground]: defaultStaticBackgroundConfig,
  [NvsBackgroundTypes.Background360]: defaultBackground360Config,
};

export const getBackgroundComponent = (backgroundText: NvsBackgroundsValue) => {
  return {
    BackgroundComponent: get(BackgroundsMap, backgroundText) as
      | BackgroundsJSXElement
      | undefined,
    defaultProps: get(BackgroundsDefaultPropMap, backgroundText),
  };
};
